import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { toRefs } from 'vue';
import {
  IonHeader,
  IonToolbar,
  IonButton,
  IonModal,
  IonContent,
  IonButtons,
} from '@ionic/vue';
import { TPackage } from '@/const/types/package';

interface Props {
  packages: TPackage[];
  isOpen: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PackagesModal',
  props: {
    packages: null,
    isOpen: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  packages: TPackage[];
  isOpen: boolean;
};




const { packages, isOpen } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), { "is-open": _unref(isOpen) }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cancel")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "ion-padding" })
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

})